export const BUSINESS_RULE = "BusinessRule";